import { useContext } from 'react';
import { SiteContext } from '../providers/site';

export const useCurrentSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useCurrentSite must be used within a SiteProvider');
  }
  return context;
};
